<div>
  <div class="flex overflow-y-auto left-0 whitespace-nowrap font-semibold animate__animated animate__slideInRight animate__delay-1s">

    <a
        (click)="goBack()"
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-2 text-white !outline-none hover:border-azulOscuro hover:text-primary"
    >
        <icon-arrow-backward />
        Volver
    </a>

    <a
       (click)="goToEditProfile()"
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-2 text-primary !outline-none hover:border-azulOscuro hover:text-primary"
    >
        <icon-user-plus />
        editar perfil
    </a>

</div>
  <div class="bg-center bg-azulOscuro flex items-center justify-center animate__animated animate__fadeIn animate__delay-1s">
    <!-- <img
      *ngIf="isDarkMode === false"
      src="../../../../assets/images/logo-23.png"
      alt="img"
      class="w-40 flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s"
    />
    <img
      *ngIf="isDarkMode === true"
      src="../../../../assets/images/logo-23.png"
      alt="img"
      class="w-40 flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s"
    /> -->
  </div>
  <app-panel-start></app-panel-start>
  <div class="pt-2 bg-azulOscuro">


    <!-- <div class="grid grid-cols-1 gap-5 lg:grid-cols-1">
        <app-data-documents (vehicleSelected)="selectVehicle($event)"></app-data-documents>
          <div *ngIf="selectedVehicle" class="modal-overlay backdrop-blur-md" (click)="closeModal()">
            <div
              class="modal-content rounded-lg shadow-lg"
              (click)="$event.stopPropagation()">
              <button class="close-btn text-black" (click)="closeModal()">✖</button>
              <app-ods [vehicleId]="selectedVehicle"></app-ods>
            </div>
          </div>

    </div> -->
</div>
</div>
<!-- <app-data-vehicle></app-data-vehicle> -->

